package com.nonopn.skywatcher.common.app.pages.administrators

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionUser
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import eu.codlab.compose.widgets.TextNormal

private val paddingInRow = 8.dp
private val paddingInBetween = 4.dp
private val cornerSide = 4.dp

@Composable
fun RenderUserRow(
    modifier: Modifier = Modifier,
    canInvite: Boolean,
    user: ThunderDetectionUser,
    onLongClick: (ThunderDetectionUser) -> Unit,
) {
    Column(
        modifier.padding(cornerSide)
            .clip(RoundedCornerShape(cornerSide))
    ) {
        DefaultCard(
            modifier = Modifier.fillMaxWidth(),
            elevation = 10.dp,
            backgroundColor = defaultCardBackground(),
            onClick = if (canInvite && !user.isOwner) {
                { /* nothing */ }
            } else null,
            onLongClick = if (canInvite && !user.isOwner) {
                { onLongClick(user) }
            } else null
        ) {
            Column(
                Modifier.padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                TextNormal(
                    text = user.email,
                    fontWeight = FontWeight.Bold,
                    fontSize = LocalFontSizes.current.administrators.cardUserEmail
                )

                TextNormal(
                    text = "#${user.uuid}",
                    fontSize = LocalFontSizes.current.administrators.cardUserUuid
                )
            }
        }
    }
}
